// @flow

import React, { Component } from 'react';
import { Select } from '../../redesign/Select';
import type Person from '../../../models/ArrivalDeparture/Person';

type Props = {
  persons: Person[],
  onChange: (number) => void,
  value: ?number,
};

export default class SelectGroup extends Component<Props> {
  render() {
    const { persons, onChange, value } = this.props;

    return (
      <div className="select-group">
        <Select
          name="person-select"
          placeholder=""
          onChange={(event) => {
            onChange(parseInt(event.target.value));
          }}
          value={value}
          options={persons.map((person: Person) => {
            return {
              value: person.mpi,
              label: person.name,
            };
          })}
        />
      </div>
    );
  }
}
